var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPublic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "15px",
    viewBox: "0 0 22 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 6") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pool-List",
    transform: "translate(-355.000000, -455.000000)",
    fill: "#C5C5C5",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "translate(130.000000, 392.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-21",
    transform: "translate(142.000000, 22.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(83.000000, 41.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6723516,14.184274 L21.975137,14.184274 C21.975137,11.742726 19.9958402,9.763379 17.554242,9.763379 L13.2108493,9.763379 C12.3544064,9.763379 11.5580365,10.0109895 10.8815114,10.4334247 C11.9729726,11.3204566 12.6724521,12.6716986 12.6724521,14.184274 L12.6723516,14.184274 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.50294521,4.6579726 C9.82609406,6.64942466 8.47346575,8.52595434 6.48196347,8.84907306 C4.4903105,9.17241781 2.61378082,7.81979452 2.2906621,5.82829224 C1.96751324,3.83663927 3.31994064,1.96010959 5.31164384,1.63699087 C7.30309589,1.31384201 9.17962557,2.66626941 9.50294521,4.6579726",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4672374,4.0843653 C19.4672374,6.34011872 17.6386256,8.16873059 15.3828721,8.16873059 C13.1271187,8.16873059 11.2985068,6.34011872 11.2985068,4.0843653 C11.2985068,1.82861187 13.1271187,-5.56754034e-14 15.3828721,-5.56754034e-14 C17.6386256,-5.56754034e-14 19.4672374,1.82861187 19.4672374,4.0843653",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.64408676,11.6989772 L8.79296804,11.0793607 L9.3633105,10.5348858 C8.89418813,10.338684 8.3793379,10.2295932 7.83898174,10.2295932 L3.95412329,10.2295932 C1.77034703,10.2297893 0,12.0001411 0,14.1839174 L10.9141096,14.1839174 C10.9141096,13.192511 10.4510648,12.2867941 9.64388584,11.6989721 L9.64408676,11.6989772 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7456393,13.600621 C11.7301393,13.4962416 11.7118919,13.3926457 11.6883489,13.2912046 C11.6777537,13.2450965 11.665393,13.1993822 11.6530323,13.1538603 C11.6253676,13.0520324 11.5941698,12.9515758 11.5588542,12.853274 C11.5455126,12.8157991 11.5323668,12.7783233 11.5178474,12.7412397 C11.4711506,12.6225352 11.4193547,12.5065781 11.3616674,12.3939562 C11.3549966,12.3808104 11.3493068,12.3672724 11.3424395,12.3541266 C11.1305363,11.9511248 10.8511464,11.5889485 10.5191473,11.2826563 C10.5158118,11.279517 10.5122801,11.2765742 10.5089449,11.2734349 C10.3984828,11.1721947 10.2825258,11.0768363 10.1612696,10.9885449 C9.91444265,10.808823 9.64838831,10.6544111 9.36309151,10.5351189 L8.79274904,11.0795938 L9.64386776,11.6992102 C10.4510367,12.2868312 10.9140915,13.1926988 10.9140915,14.1841554 L11.7930869,14.1841554 L11.7930869,14.1839592 C11.7930869,14.0313103 11.7824918,13.881414 11.7656181,13.7334715 C11.7609092,13.6885408 11.7522764,13.6449843 11.7456051,13.6006428 L11.7456393,13.600621 Z",
    id: "Path"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPublic);
export default __webpack_public_path__ + "static/media/public.e57876493659d34ec2eb2405c28022f1.svg";
export { ForwardRef as ReactComponent };